export type AuthSession = {
  token: string
  uid: string
  displayName: string
  username: string
}

const AUTH_SESSION_KEY = "pac_auth_session"

export function getAuthSession(): AuthSession | null {
  try {
    const raw = localStorage.getItem(AUTH_SESSION_KEY)
    if (!raw) return null
    return JSON.parse(raw) as AuthSession
  } catch {
    return null
  }
}

export function setAuthSession(session: AuthSession): void {
  localStorage.setItem(AUTH_SESSION_KEY, JSON.stringify(session))
}

export function clearAuthSession(): void {
  localStorage.removeItem(AUTH_SESSION_KEY)
}

export function getAuthToken(): string | null {
  return getAuthSession()?.token ?? null
}

export async function registerAccount(
  username: string,
  password: string,
  displayName?: string
): Promise<AuthSession> {
  const res = await fetch("/auth/register", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ username, password, displayName })
  })
  const body = await res.json().catch(() => ({}))
  if (!res.ok) {
    throw new Error(body.error ?? "Registration failed")
  }
  setAuthSession(body)
  return body
}

export async function loginAccount(
  username: string,
  password: string
): Promise<AuthSession> {
  const res = await fetch("/auth/login", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ username, password })
  })
  const body = await res.json().catch(() => ({}))
  if (!res.ok) {
    throw new Error(body.error ?? "Login failed")
  }
  setAuthSession(body)
  return body
}
